const MS_PER_DAY = 24 * 60 * 60 * 1000;
const GESTATION_DAYS = 280; // standard 40-week pregnancy
const FIRST_TRIMESTER_END_DAYS = 91; // 13 weeks
const SECOND_TRIMESTER_END_DAYS = 196; // 28 weeks
export const getTrimester = (expectedDueDate, today = new Date()) => {
    const daysUntilDue = Math.round((expectedDueDate.getTime() - today.getTime()) / MS_PER_DAY);
    if (daysUntilDue <= 0)
        return 'postpartum';
    const gestationalDays = GESTATION_DAYS - daysUntilDue;
    if (gestationalDays < FIRST_TRIMESTER_END_DAYS)
        return '1st';
    if (gestationalDays < SECOND_TRIMESTER_END_DAYS)
        return '2nd';
    return '3rd';
};
//# sourceMappingURL=getTrimester.js.map